import React from 'react';
import moment from 'moment-timezone';

import { CoachAvailabilityInterval } from 'globalTypes';
import Columns2 from 'components/Columns2';
import Icon from 'components/Icon';
import Link from 'components/Link';
import MediaObject from 'components/MediaObject';
import Row from 'components/Row';
import Text from 'components/Text';
import { getWeekdayForWeekOffset } from 'coaching/lib/timeIntervals';

type Props = {
  dayOfWeek: string;
  dayOfWeekIndex: number;
  weekOffset: number;
  intervals: CoachAvailabilityInterval[];
  onRemove?: () => void;
};

export default function CoachingAvailabilityDayRow(props: Props) {
  return (
    <Columns2>
      <Text size="medium" weight="semibold" lineHeight="large">
        {getWeekdayForWeekOffset(props.dayOfWeekIndex, props.weekOffset).format('ddd, MMM D')}
      </Text>
      <Text size="medium" lineHeight="large">
        {props.intervals.map(interval => (
          <MediaObject figure="right" center key={interval.startTime}>
            <Row key={`${props.dayOfWeek}-${interval.startTime}`} size="xsmall">
              <Text>{moment(interval.startTime, 'HH:mm').format('h:mm A')}</Text> -{' '}
              <Text>{moment(interval.endTime, 'HH:mm').format('h:mm A')}</Text>
            </Row>
            {props.onRemove ? (
              <Link onClick={props.onRemove} data-test="remove-time-off">
                <Text align="right" element="div" lineHeight="flush">
                  <Icon name="x" color="graphite" size="small" />
                </Text>
              </Link>
            ) : (
              <span />
            )}
          </MediaObject>
        ))}
      </Text>
    </Columns2>
  );
}
